<form>
	<custom-input [inputType]="inputTypeEnum.Text"
				  [(value)]="pointerName"
				  [customValidState]="validate()"
				  [customValidationMessage]="validationMessage"
				  [required]="true"
				  [placeholder]="'site.name-placeholder' | translate"></custom-input>
	<button small #addPointerButton
			confirm
			[label]="'site.button.add-pointer' | translate"
			(click)="addPointer(pointerName, site)"></button>
</form>
